<template>
  <div class="relative w-full h-full">
    <div class="w-full h-[calc(100%-75px)] overflow-x-auto overflow-y-auto">
      <table class="relative h-full w-full rounded-xl border-green-500">
        <thead
          class="w-full border-1 bg-light-box-background dark:bg-dark-box-background transition ease-in-out duration-side-menu-transition-duration"
          style="position: sticky; top: 0">
          <tr
            class="border-b-1 dark:border-dark-divider-border text-left text-common-grey transition ease-in-out duration-side-menu-transition-duration">
            <th
              v-for="(header, index) in headers"
              :key="index"
              class="px-6 py-3 whitespace-nowrap font-medium text-gray-600 dark:text-white"
              :style="{ backgroundColor: `${index > 0 ? column_colors[index - 1] : ''}` }">
              {{ header }}
            </th>
          </tr>
        </thead>
        <tbody
          ref="records_table"
          class="bg-light-box-background divide-light-divider-border dark:divide-dark-divider-border dark:bg-dark-box-background transition ease-in-out duration-side-menu-transition-duration">
          <tr
            v-for="(row, index_row) in formated_table_data"
            :key="index_row"
            class="group border-t-[1px] text-sm text-light-body-text dark:text-dark-body-text transition ease-in-out">
            <td
              v-for="(value, index_value) in row"
              :key="index_value"
              class="px-6 py-3 font-light capitalize"
              :class="[index_value == 0 ? 'font-medium' : '']"
              :style="{ backgroundColor: `${index_value > 0 ? column_colors[index_value - 1] : ''}` }">
              {{ value }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "Chart",
  props: {
    axis: {
      type: Object,
      required: false
    },
    labels: {
      type: Array,
      default: () => [0, 1, 2, 3]
    },
    chartdata: {
      type: Array,
      default: () => [110, 90, 80, 70, 60, 50, 40, 35, 30, 25, 15]
    },
    graph: null
  },
  data() {
    return {
      column_colors: [],
      formattedChartData: [],
      toFixedChartData: [],
      formattedLables: [],
      headers: [],
      formated_table_data: []
    }
  },
  created() {
    if (this.axis?.name) {
      this.headers.push(this.axis.name)
    } else {
      this.headers.push(this.$t("Parent"))
    }
    let labels = this.graph.datasets.labels || this.labels
    this.chartdata.map((x) => {
      this.headers.push(x.label)
      if (x.data.length > 0) {
        this.formattedChartData.push(x.data.map((point) => this.formatPoint(point)))
      }
      this.toFixedChartData.push(x.data.map((point) => this.formatPoint(point)))
      this.column_colors.push(x.backgroundColor[0])
    })
    this.formattedLables = labels.map((point) => (Number(point) ? this.formatPoint(Number(point)) : point))
    this.formattedLables.map((value, index) => {
      let row = []
      row.push(value)
      this.formattedChartData.map((serie) => {
        row.push(serie[index])
      })
      this.formated_table_data.push(row)
    })
  },
  methods: {
    formatPoint(datapoint) {
      return this.$utils.truncateNumber(datapoint)
    }
  }
}
</script>
